module.exports = __webpack_public_path__ + "img/icon-management.5502f400.png";